import $ from 'jquery';

class ExpressionComparator{
	constructor(){
		this.hasSpacesPattern = /\s/;
		this.nonAlphaNumOnlyPattern = /[^A-Za-z0-9]/;
		this.nonAlphaOnlyPattern = /[^A-Za-z]/;
		this.nonNumOnlyPattern = /[^0-9]/;
		this.nonNumAndDashOnlyPattern = /[^0-9\-]/;
		this.validEmailPattern   = /^[^@ ]+@[^.@ ]+\.[^@ ]+$/;
		this.validPhoneNumberPattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
		this.invalidEmailPattern = /%/;
	}
	getValidationStatus(){
		return{
			'isValid':true,
			'msg':null
		}
	}

	/* common expression methods for form validations */
	empty(val){
		var vs = this.getValidationStatus();
		if(val == ''){
			vs.isValid = false;
			vs.msg = 'This field is required';
		}
		return vs;
	}
	email(val){
		var vs = this.getValidationStatus();
		if(!this.validEmailPattern.test(val) || this.invalidEmailPattern.test(val)) {
			vs.isValid = false;
			vs.msg = 'Please enter a valid email address.';
		}else if (val.match(/[<>"&]/)) {
			vs.isValid = false;
			vs.msg = 'Please avoid special characters &lt;, &gt;, &quot;, and &amp;.';
		}else{}
		return vs;
	}
	zipcode(val){
		var vs = this.getValidationStatus();
		if(val.length != 5){
			vs.isValid = false;
			vs.msg = 'Please enter your 5 digit zipcode';
		}
		return vs;
	}
	phone(val){
		var vs = this.getValidationStatus();
		if(val.length != 13){
			vs.isValid = false;
			vs.msg = 'Please enter your 10 digit phone number';
		}
		return vs;
	}
	duedate(val){
		var vs = this.getValidationStatus();
		if(val.length != 10){
			vs.isValid = false;
			vs.msg = 'Please enter baby\'s DOB or your Due date in the following format: xx/xx/xxxx';
		}
		return vs;
	}
	state(val){
		var vs = this.getValidationStatus();
		if(val==-1){
			vs.isValid = false;
			vs.msg = 'Please enter your state';
		}
		return vs;
	}
	minCount_6(val){
		var vs = this.getValidationStatus();
		if(val.length < 6){
			vs.isValid = false;
			vs.msg = 'This field needs 6 or more characters.';
		}
		return vs;
	}
	checkSame_password(val){
		var vs = this.getValidationStatus();
		if($('#password').val() !== val){
			vs.isValid = false;
			vs.msg = 'This field needs to be same as the Password field.';
		}else{}
		return vs;
	}
}

const _ec = new ExpressionComparator();
Object.freeze(_ec);
export default _ec;



// WEBPACK FOOTER //
// ./ExpressionComparator.js